// extracted by mini-css-extract-plugin
module.exports = {"buttons":"styles_buttons__2SlWN","inscription":"styles_inscription__1_cCs","actions":"styles_actions__3J7yB"};